import { render, staticRenderFns } from "./createPhoneNumber.vue?vue&type=template&id=4797f712&"
import script from "./createPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./createPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports